var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuesttionaireIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9997 3.83398H14.9997C14.0792 3.83398 13.333 4.58018 13.333 5.50065V8.83398C13.333 9.75446 14.0792 10.5007 14.9997 10.5007H24.9997C25.9201 10.5007 26.6663 9.75446 26.6663 8.83398V5.50065C26.6663 4.58018 25.9201 3.83398 24.9997 3.83398Z",
    stroke: "#0094FB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 7.16602H30.0003C30.8844 7.16602 31.7322 7.5172 32.3573 8.14233C32.9825 8.76745 33.3337 9.61529 33.3337 10.4993V33.8327C33.3337 34.7167 32.9825 35.5646 32.3573 36.1897C31.7322 36.8148 30.8844 37.166 30.0003 37.166H10.0003C9.11627 37.166 8.26842 36.8148 7.6433 36.1897C7.01818 35.5646 6.66699 34.7167 6.66699 33.8327V10.4993C6.66699 9.61529 7.01818 8.76745 7.6433 8.14233C8.26842 7.5172 9.11627 7.16602 10.0003 7.16602H13.3337",
    stroke: "#0094FB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.834H26.6667",
    stroke: "#0094FB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 27.166H26.6667",
    stroke: "#0094FB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 18.834H13.3505",
    stroke: "#0094FB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 27.166H13.3505",
    stroke: "#0094FB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuesttionaireIcon);
export default __webpack_public_path__ + "static/media/QuesttionaireIcon.7b7c1e1241107b36ad42329af6ade8c2.svg";
export { ForwardRef as ReactComponent };